<template>
  <button
    v-if="isButton || isModal"
    class="BaseLink"
    @click="handleClick"
  >
    <slot />
  </button>

  <a
    v-else-if="to.startsWith('http')"
    v-bind="$attrs"
    :href="to"
    class="BaseLink"
    target="_blank"
  >
    <slot />
  </a>

  <a
    v-else
    v-bind="$attrs"
    :href="isAnchor ? to : resolveLocalePath(to)"
    class="BaseLink"
  >
    <slot />
  </a>
</template>

<script>
export default {

  props: {
    to: {
      type: String,
      default: '/'
    },
    isButton: {
      type: Boolean,
      default: false
    }
  },

  emits: ['click'],

  setup() {
    const modalStore = useModalStore()
    const { resolveLocalePath } = useUrlBuilder()

    return { modalStore, resolveLocalePath }
  },

  computed: {
    isModal () {
      return this.to?.startsWith('@modal:')
    },
    isAnchor () {
      return this.to?.startsWith('#')
    }
  },

  methods: {
    handleClick (event) {
      if (this.isModal) {
        return this.modalStore.OPEN_MODAL_PAGE({ slug: this.to.replace('@modal:', '') })
      }

      return this.$emit('click', event)
    }
  }
}
</script>
